import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../../../environments/environment';
import { LucideAngularModule } from 'lucide-angular';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
	selector: 'app-register-renaper',
	standalone: true,
	imports: [CommonModule, MatButtonModule, LucideAngularModule],
	templateUrl: './register_renaper.html',
	styleUrl: './register_renaper.scss'
})
export class RegisterRenaperComponent {
	@Input() hasError = false;
	@Output() renaperValidated = new EventEmitter<any>();

	private authService = inject(AuthService);

	faqURL = environment.faqURL;

	inicioURL = environment.rootURL;

	iniciarAutenticacion(): void {
		const finalRedirect = encodeURIComponent(window.location.origin + '/register');
		window.location.href = `${environment.autenticarUrl}?final_redirect=${finalRedirect}`;
	}

	goToLogin(): void {
		this.authService.login();
	}
}
